import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { blog_delete_type, get_create_blog, replace_blog_post } from "../../reduxData/user/userAction";
import { useSelector } from "react-redux";
import { set } from "date-fns";
import DeletePopup from "../../Modals/DeletePopup";

const BlogDetail = () => {
    const navigate = useNavigate()
    const imageURL = process.env.REACT_APP_IMAGE_URL;
    const [data, setData] = useState([])
    const {user} = useSelector(state=>state?.auth);

    const [open ,setOpen] = useState(false);
    const [blogId ,setBlogId] = useState("");

    const getData = async () => {
        const res = await get_create_blog();
        // Sort once here after fetching
        const sortedData = res?.data?.sort((a, b) => a.position_index - b.position_index);
        setData(sortedData);
    };
    const delete_blog = async () => {
        await blog_delete_type(blogId);
        setOpen(false);
        setBlogId("");
        getData()
    }
    useEffect(() => {
        getData()
    }, [])
    const formatDate = (inputdate) => {
        const date = new Date(inputdate);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = days[date.getUTCDay()];
        const dayOfMonth = date.getUTCDate();
        const month = months[date.getUTCMonth()];
        const year = date.getUTCFullYear();
        return `${dayOfMonth} ${month} ${year}`;
    };
    const dragItem = useRef(null);
    const dragOverItem = useRef(null);
    const handleSort = () => {
        const _data = [...data];
        const fromIndex = dragItem.current;
        const toIndex = dragOverItem.current;
        if (fromIndex === toIndex) return;
        const fromItem = _data[fromIndex];
        const toItem = _data[toIndex];
        _data.splice(fromIndex, 1);
        _data.splice(toIndex, 0, fromItem);

        const updatedData = _data.map((item, index) => ({
            ...item,
            position_index: index + 1
        }));

        dragItem.current = null;
        dragOverItem.current = null;

        setData(updatedData);

        const payload = {
            blog_post_id_from: fromItem.blog_post_id,
            position_index_from: fromItem.position_index,
            blog_post_id_to: toItem.blog_post_id,
            position_index_to: toItem.position_index
        };

        console.log("Payload:", payload);
        replace_blog_post(payload);
    };


    return (
        <>
            <div className=" container-xxl border border-1 p-3">
                <div className="d-flex justify-content-between align-items-center">
                    <h5 className=" text-black fs-4 mb-0 fw-semibold">Blogs Management</h5>
                    <button onClick={() => navigate("/blogs", { state: { length: data?.length } })} className="btn common-button">Add Blog</button>
                </div>


                <div className="table-responsive mt-4">
                    <table className="table user-management-table table-hover">
                        <thead className="border-gray">
                            <th>Sr.No</th>
                            <th>Category</th>
                            <th>Author Image</th>
                            <th>Created at</th>
                            <th>Action</th>
                        </thead>
                        <tbody>
                            {data?.map((value, index) => (
                                <tr
                                    key={value?.blog_post_id}
                                    draggable
                                    onDragStart={() => (dragItem.current = index)}
                                    onDragEnter={() => (dragOverItem.current = index)}
                                    onDragEnd={handleSort}
                                    onDragOver={(e) => e.preventDefault()}
                                >
                                    <td>{index+1}</td>
                                    <td className="text-capitalize">{value?.type_name}</td>
                                    <td>
                                        <div className="img-blog-author">
                                            <img
                                                src={`${imageURL}${value?.author_image}`}
                                                alt=""
                                                className="img-fluid"
                                            />
                                        </div>
                                    </td>
                                    <td>{formatDate(value?.created_at)}</td>
                                    <td>
                                        <div className="d-flex gap-1 align-items-center">
                                            <i
                                                className="far fa-edit edit pointer"
                                                onClick={() =>
                                                    navigate(`/editblogs/${value?.blog_post_id}`, {
                                                        state: { api: "edit" }
                                                    })
                                                }
                                            />
                                        {user?.role!="store-manager" &&  <i
                                                onClick={() => 
                                                    // delete_blog(value?.blog_post_id)
                                                    {
                                                        setBlogId(value?.blog_post_id);
                                                        setOpen(true);
                                                    }
                                                }
                                                className="bi bi-trash3 text-danger fs-6 pointer"
                                            />
                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>

             {open && <DeletePopup  open={open} setOpen={setOpen} handleDelete={delete_blog}  label="Are you sure , you want to delete the Blog" />}
            </div>
        </>
    )
}
export default BlogDetail;
